import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { scrollToTop } from '../header';
import destinationsEn from '../../data/destinationsData';
import destinationsTh from '../../data/destinationData.th';
import '../Destination/style.css';

const Destination3 = () => {
  const { t, i18n } = useTranslation();
  const [activeOrigin, setActiveOrigin] = useState(null);
  
  console.log('Current language:', i18n.language); // Debug language
  console.log('Destinations EN:', destinationsEn); // Debug EN data
  console.log('Destinations TH:', destinationsTh); // Debug TH data
  
  const [currentDestinations, setCurrentDestinations] = useState(() => {
    // Initialize with proper data based on current language
    console.log('Initial language:', i18n.language);
    return i18n.language === 'th' ? destinationsTh : destinationsEn;
  });

  useEffect(() => {
    console.log('Language changed to:', i18n.language); // Debug language change
    const newDestinations = i18n.language === 'th' ? destinationsTh : destinationsEn;
    console.log('New destinations:', newDestinations); // Debug new data
    setCurrentDestinations(newDestinations);
  }, [i18n.language]);

  // Replace existing destinations constant with currentDestinations
  const destinations = currentDestinations;

  const getOrigin = (title) => {
    if (!title || typeof title !== 'string') {
      return t('unknown_destination');
    }
    if (!title.includes('↔')) {
      return title.trim();
    }
    const origin = title.split('↔')[0].trim();
    return t(`origins.${origin}`);
  };

  const generateId = (str) => {
    return str
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  };

  const groupDestinations = (destinations) => {
    return destinations.reduce((acc, dest) => {
      if (!dest || !dest.Title) {
        return acc;
      }
      const translatedOrigin = getOrigin(dest.Title);
      // Get original English name from the title
      const englishOrigin = dest.Title.split('↔')[0].trim();
      
      if (!acc[translatedOrigin]) {
        acc[translatedOrigin] = {
          translatedName: translatedOrigin,
          englishName: englishOrigin,
          destinations: []
        };
      }
      acc[translatedOrigin].destinations.push(dest);
      return acc;
    }, {});
  };

  if (!destinations || destinations.length === 0) {
    return (
      <div className="destination-area">
        <div className="container">
          <div className="wpo-section-title">
            <h2>{t('no_destinations_available')}</h2>
          </div>
        </div>
      </div>
    );
  }

  const groupedDestinations = groupDestinations(destinations);
  const originCities = Object.keys(groupedDestinations);

  return (
    <div className="destination-area optimize-visibility">
      <div className="container">
        <div className="wpo-section-title">
          <h2>{t('navigation.all_destinations')}</h2>
        </div>

        <div className="destination-menu">
          <div className="destination-content" onClick={() => setActiveOrigin(activeOrigin ? null : 'menu')}>
            <div className="content-left">
              <h5>{t('destinations')}</h5>
            </div>
            <div className="content-right">
              <h5>{activeOrigin ? '-' : '+'}</h5>
            </div>
          </div>
          
          {activeOrigin === 'menu' && (
            <div className="menu-items">
              {originCities.map((origin, index) => (
                <a 
                  key={index} 
                  href={`#${generateId(groupedDestinations[origin].englishName)}`} 
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById(generateId(groupedDestinations[origin].englishName));
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  {groupedDestinations[origin].translatedName}
                </a>
              ))}
            </div>
          )}
        </div>

        {originCities.map((origin, groupIndex) => {
          const originId = generateId(groupedDestinations[origin].englishName);
          return (
            <div key={groupIndex} id={originId}>
              <div className="wpo-section-title">
                <h2>{groupedDestinations[origin].translatedName}</h2>
              </div>
              <div className="row">
                {groupedDestinations[origin].destinations.map((dest, index) => (
                  <div className="col-6 col-md-4 col-lg-3" key={index}>
                    <a
                      href={dest.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => scrollToTop()}
                    >
                      <div className="destination-item">
                        <div className="destination-img">
                          <img
                            src={dest.DImg || 'default-placeholder.webp'}
                            alt={t(dest.Title) || t('destination')}
                            loading="lazy"
                          />
                        </div>
                        <div className="destination-content">
                          <div className="content-left">
                            <h5>{i18n.language === 'th' ? t(dest.Title) : dest.Title}</h5>
                            <small>{dest.Date ? t('routes.Daily') : t('unknown_date')}</small>
                          </div>
                          <div className="content-right">
                            <h5>{dest.price || 'N/A'}</h5>
                            <span>{t('starting')}</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Destination3;
